import { em } from '@mantine/core';
import { AppPaths } from '@/configs/appPaths';

const APP_CONFIG = {
	QUERY_STALE_TIME: 30_000,
	QUERY_CACHE_TIME: 1_800_000,
	QUERY_RETRY: 2,
	EDIT_LOGOUT_TIME: 6,
	SIZE_PER_PAGE: 6,
	TEXTAREA_LIMIT: 200,
	CONTENT_MAX_WIDTH: 1360,
	Z_INDEX: {
		OVERLAY: 50,
		NOTIFICATION: 100,
		DRAWER: 104,
		HEADER: 105,
		MODAL: 301,
		POPOVER: 301,
		SCROLL_TOP: 50,
		SELECT: 302,
		TOOLTIP: 302,
	},
	ROOT_FONT_SIZE: 16,
	BREAKPOINTS: {
		XS: em(576),
		SM: em(768),
		MD: em(992),
		LG: em(1200),
		XL: em(1408),
	},
	APP_LANGUAGE: 'pl',
	AUTHENTICATED_ROUTES: [AppPaths.ACCOUNT],
} as const;

export default APP_CONFIG;
